// Helpers de geometría planar para la selección con polígono.
//
// Tratamos las coordenadas como cartesianas (lat, lon) — para el rango
// de un día de operación (≤ 50 km) el error de no proyectar a plano
// es despreciable. Si en el futuro hay polígonos grandes (multi-ciudad)
// migrar a turf.js / proyección Web Mercator.

export type LatLon = [number, number];

/// Ray-casting: el punto está dentro del polígono si una semirrecta
/// horizontal hacia +∞ cruza una cantidad impar de aristas.
/// Devuelve `false` si el polígono tiene menos de 3 vértices.
///
/// Edge case: puntos exactamente sobre una arista son indeterminados
/// (pueden caer dentro o fuera según orientación del flotante). Para
/// selección operativa no nos importa — la chance es ~0.
export function pointInPolygon(p: LatLon, polygon: LatLon[]): boolean {
  if (polygon.length < 3) return false;
  const [x, y] = p;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [xi, yi] = polygon[i];
    const [xj, yj] = polygon[j];
    const intersects =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersects) inside = !inside;
  }
  return inside;
}
